// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — time-picker.classic.js, новая — time-picker.cp.js
import { isCp } from 'libs/design';
import * as classic from './time-picker.classic';
import * as cp from './time-picker.cp';

export const TimePicker = isCp ? cp.TimePicker : classic.TimePicker;
